// Colors mirror the CSS custom properties in src/index.css (--success-color,
// --danger-color, --warning-color) so the hero matches the badge colors a
// provider already saw on the Results list they clicked from.
export const TIER_COLORS = {
  success: '#5cb85c',
  danger: '#d9534f',
  warning: '#f0ad4e',
  neutral: '#8a8a8a',
}

// Keyed on the canonical stored labTestResult enum values
// (models/Kit.js: 'none' | 'NSS' | 'Positive' | 'error') — not display strings.
export const RESULT_TIERS = {
  NSS: { tier: 'success', label: 'NSS - No Sperm Seen', icon: 'check' },
  Positive: { tier: 'danger', label: 'Positive — sperm seen', icon: 'triangle-exclamation' },
  error: { tier: 'warning', label: 'Test Error - Retest may be required.', icon: 'triangle-exclamation' },
  none: { tier: 'neutral', label: 'Not tested yet', icon: 'clock' },
}

export const DEFAULT_TIER = { tier: 'neutral', label: 'Result unavailable', icon: 'circle-question' }

export const getResultTier = (result) => RESULT_TIERS[result] ?? DEFAULT_TIER
